'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, useRef } from 'react';
import { FilterIcon } from '@/components/atoms/Icons';
import { useExplore } from './ExploreProvider';
import { LocationFinder } from './LocationFinder';
import { FilterModal } from './FilterModal';
import { SearchAutofill } from './SearchAutofill';

/**
 * Atomic: Search Input with icon, autofill dropdown, and clear button
 */
export function SearchInput(t0) {
  const $ = _c(58);
  const {
    placeholder: t1,
    className: t2,
    serchInputClass: t3,
    searchClass: t4,
    id: t5
  } = t0;
  const placeholder = t1 === undefined ? "by Heart, Artist, Location..." : t1;
  const className = t2 === undefined ? "" : t2;
  const serchInputClass = t3 === undefined ? "" : t3;
  const searchClass = t4 === undefined ? "" : t4;
  const id = t5 === undefined ? "" : t5;
  const {
    searchQuery,
    search,
    setSearchQuery,
    clearSearch,
    commitSearch,
    isLoading,
    filters,
    filterMarkers,
    initialMarkers,
    setMapCenter,
    setMapZoom
  } = useExplore();
  const [inputValue, setInputValue] = useState(searchQuery);
  const [isAutofillOpen, setIsAutofillOpen] = useState(false);
  const containerRef = useRef(null);
  let t6;
  let t7;
  if ($[0] !== searchQuery) {
    t6 = () => {
      setInputValue(searchQuery);
    };
    t7 = [searchQuery];
    $[0] = searchQuery;
    $[1] = t6;
    $[2] = t7;
  } else {
    t6 = $[1];
    t7 = $[2];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      const handleClickOutside = function handleClickOutside(event) {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
          setIsAutofillOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    };
    t9 = [];
    $[3] = t8;
    $[4] = t9;
  } else {
    t8 = $[3];
    t9 = $[4];
  }
  useEffect(t8, t9);
  let t10;
  if ($[5] !== inputValue || $[6] !== search) {
    t10 = e => {
      e.preventDefault();
      if (inputValue.trim()) {
        search(inputValue);
      }
      setIsAutofillOpen(false);
    };
    $[5] = inputValue;
    $[6] = search;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const handleSubmit = t10;
  let t11;
  if ($[8] !== setSearchQuery) {
    t11 = e_0 => {
      const value = e_0.target.value;
      setInputValue(value);
      setSearchQuery(value);
      setIsAutofillOpen(value.trim().length > 0);
    };
    $[8] = setSearchQuery;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  const handleInputChange = t11;
  let t12;
  if ($[10] !== inputValue) {
    t12 = () => {
      if (inputValue.trim().length > 0) {
        setIsAutofillOpen(true);
      }
    };
    $[10] = inputValue;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  const handleFocus = t12;
  let t13;
  if ($[12] !== commitSearch || $[13] !== search || $[14] !== setMapCenter || $[15] !== setMapZoom || $[16] !== setSearchQuery) {
    t13 = item => {
      setInputValue(item.name);
      setSearchQuery(item.name);
      search(item.name);
      commitSearch();
      setIsAutofillOpen(false);
      if (item.location) {
        setMapCenter(item.location);
        setMapZoom(15);
      }
    };
    $[12] = commitSearch;
    $[13] = search;
    $[14] = setMapCenter;
    $[15] = setMapZoom;
    $[16] = setSearchQuery;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  const handleSelectSuggestion = t13;
  let t14;
  if ($[18] !== clearSearch) {
    t14 = () => {
      setInputValue("");
      setIsAutofillOpen(false);
      clearSearch();
    };
    $[18] = clearSearch;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  const handleClear = t14;
  let t15;
  let t16;
  if ($[20] !== inputValue || $[21] !== search || $[22] !== searchQuery) {
    t15 = () => {
      const timeoutId = setTimeout(() => {
        if (inputValue !== searchQuery) {
          search(inputValue);
        }
      }, 300);
      return () => clearTimeout(timeoutId);
    };
    t16 = [inputValue, searchQuery, search];
    $[20] = inputValue;
    $[21] = search;
    $[22] = searchQuery;
    $[23] = t15;
    $[24] = t16;
  } else {
    t15 = $[23];
    t16 = $[24];
  }
  useEffect(t15, t16);
  const t17 = `flex-1 relative ${className}`;
  let t18;
  if ($[25] !== id) {
    t18 = <label htmlFor={id} className="sr-only">Search</label>;
    $[25] = id;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  const t19 = `w-full px-4 py-3 pr-10 pl-4 lg:h-12.5 h-11 font-semibold text-lg placeholder:text-[#757575] text-gray-900 bg-white border border-[#dddddd] 
              shadow-sm focus:outline-none ${isAutofillOpen ? "rounded-t-[10px] border-b-0" : "rounded-[10px] focus:ring-1 focus:ring-[#00EAFD]"} ${serchInputClass}`;
  let t20;
  if ($[27] !== handleFocus || $[28] !== handleInputChange || $[29] !== id || $[30] !== inputValue || $[31] !== isLoading || $[32] !== placeholder || $[33] !== t19) {
    t20 = <input id={id} type="text" value={inputValue} onChange={handleInputChange} onFocus={handleFocus} placeholder={placeholder} className={t19} disabled={isLoading} autoComplete="off" />;
    $[27] = handleFocus;
    $[28] = handleInputChange;
    $[29] = id;
    $[30] = inputValue;
    $[31] = isLoading;
    $[32] = placeholder;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== handleClear || $[36] !== inputValue || $[37] !== isLoading || $[38] !== searchClass) {
    t21 = inputValue ? <button type="button" onClick={handleClear} className={`absolute right-2 cursor-pointer top-1/2 transform -translate-y-1/2 ${searchClass}`} aria-label="Clear search"><svg className="w-5 h-5 text-[#A8A8A8]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg></button> : <div className={`absolute right-2 top-1/2 transform -translate-y-1/2 ${searchClass}`}><svg className={`w-5 h-5 ${isLoading ? "text-blue-500 animate-spin" : "text-[#A8A8A8]"}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">{isLoading ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" /> : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />}</svg></div>;
    $[35] = handleClear;
    $[36] = inputValue;
    $[37] = isLoading;
    $[38] = searchClass;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== t18 || $[41] !== t20 || $[42] !== t21) {
    t22 = <div className="relative flex items-center">{t18}{t20}{t21}</div>;
    $[40] = t18;
    $[41] = t20;
    $[42] = t21;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== filterMarkers || $[45] !== filters || $[46] !== handleSelectSuggestion || $[47] !== initialMarkers || $[48] !== inputValue || $[49] !== isAutofillOpen) {
    t23 = <SearchAutofill query={inputValue} items={initialMarkers} filters={filters} filterMarkers={filterMarkers} onSelect={handleSelectSuggestion} isOpen={isAutofillOpen} />;
    $[44] = filterMarkers;
    $[45] = filters;
    $[46] = handleSelectSuggestion;
    $[47] = initialMarkers;
    $[48] = inputValue;
    $[49] = isAutofillOpen;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== handleSubmit || $[52] !== t22 || $[53] !== t23) {
    t24 = <form onSubmit={handleSubmit} className="relative">{t22}{t23}</form>;
    $[51] = handleSubmit;
    $[52] = t22;
    $[53] = t23;
    $[54] = t24;
  } else {
    t24 = $[54];
  }
  let t25;
  if ($[55] !== t17 || $[56] !== t24) {
    t25 = <div className={t17} ref={containerRef}>{t24}</div>;
    $[55] = t17;
    $[56] = t24;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  return t25;
}

/**
 * Atomic: Filter Button with badge
 */
export function FilterButton(t0) {
  const $ = _c(15);
  const {
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const {
    getActiveFilterCount
  } = useExplore();
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsFilterModalOpen(true);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = `relative flex items-center justify-between p-3 bg-white lg:border border-[#dddddd] rounded-[10px] shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#00EAFD] lg:min-w-[150px] xl:min-w-[200px] ${className}`;
  let t4;
  let t5;
  let t6;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="sr-only">filter</span>;
    t5 = <span className="hidden lg:block ml-2 text-[#757575] text-[16px] font-[500]">Filters / Sort</span>;
    t6 = <FilterIcon className="w-5 h-5 text-[#A8A8A8]" />;
    $[1] = t4;
    $[2] = t5;
    $[3] = t6;
  } else {
    t4 = $[1];
    t5 = $[2];
    t6 = $[3];
  }
  let t7;
  if ($[4] !== getActiveFilterCount) {
    t7 = getActiveFilterCount() > 0 && <span className="absolute top-2.25 right-1 w-3 h-3 rounded-full bg-[#00EAFD]" suppressHydrationWarning={true} />;
    $[4] = getActiveFilterCount;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== t3 || $[7] !== t7) {
    t8 = <button onClick={t2} className={t3}>{t4}{t5}{t6}{t7}</button>;
    $[6] = t3;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setIsFilterModalOpen(false);
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== isFilterModalOpen) {
    t10 = <FilterModal isOpen={isFilterModalOpen} onClose={t9} />;
    $[10] = isFilterModalOpen;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t8) {
    t11 = <>{t8}{t10}</>;
    $[12] = t10;
    $[13] = t8;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  return t11;
}

/**
 * Atomic: Location Button (re-export for consistency)
 */
export { LocationFinder as LocationButton } from './LocationFinder';

/**
 * Container for composing search bar elements
 */
export function SearchBarContainer(t0) {
  const $ = _c(3);
  const {
    children,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const t2 = `flex items-center ${className}`;
  let t3;
  if ($[0] !== children || $[1] !== t2) {
    t3 = <div className={t2}>{children}</div>;
    $[0] = children;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
}

/**
 * Legacy: Composed SearchBar for backward compatibility
 * Use atomic components for new implementations
 */
export function SearchBar(t0) {
  const $ = _c(10);
  const {
    placeholder: t1,
    showFilterButton: t2,
    showLocationButton: t3
  } = t0;
  const placeholder = t1 === undefined ? "by Heart, Artist, Location..." : t1;
  const showFilterButton = t2 === undefined ? true : t2;
  const showLocationButton = t3 === undefined ? true : t3;
  let t4;
  if ($[0] !== placeholder) {
    t4 = <SearchInput placeholder={placeholder} id="searchInput" />;
    $[0] = placeholder;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== showFilterButton) {
    t5 = showFilterButton && <FilterButton />;
    $[2] = showFilterButton;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== showLocationButton) {
    t6 = showLocationButton && <LocationFinder />;
    $[4] = showLocationButton;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t4 || $[7] !== t5 || $[8] !== t6) {
    t7 = <SearchBarContainer>{t4}{t5}{t6}</SearchBarContainer>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
}